<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NhErIL/tc-custom/9781473885127.jpg?1705807838478" alt="This image is the cover for the book Sir John Moore"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sir John Moore
      </h1>
      <p class="bookDescription body article font2">
        <p>Sir John Moore is perhaps the second most famous British soldier of the Napoleonic Wars after the Duke of Wellington, yet his remarkable career has been neglected in comparison to his celebrated contemporary.  His death in battle at Corunna overshadows the wide range of his earlier campaigns and his achievements as an innovative soldier. Janet Macdonalds fluently written and insightful biography focuses on the development of his character as well as his career as a commander. From it emerges a many-sided portrait of a fascinating man and an outstanding soldier, a key figure in the history of the British army.    Admired by his peers but distrusted by his political masters, Moore was a controversial figure. He is best known for saving the British army in Spain by leading the retreat to Corunna, but he is also credited with developing the training system that enabled Wellingtons army to beat the French in Spain and at Waterloo. Janet Macdonalds account will rekindle interest in a leading actor in the struggle against the French revolutionary and Napoleonic armies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Macdonald
      </h2>
      
      <p class="authorDescription body article">Janet Macdonald has published books on numerous subjects. Her first book on naval history was Feeding Nelson's Navy: The True Story of Food at Sea in the Georgian Era; her second, the British Navy's Victualling Board, 1793–1815: Management Competence and Incompetence. She took her MA in Maritime History at the Greenwich Maritime Institute, London, and her PhD at King's College London, where she was awarded a Laughton Scholarship. Her thesis was on the administration of naval victualling. Her most recent books are From Boiled Beef to Chicken Tikka: 500 Years of Feeding the British Army, Sir John Moore: The Making of a Controversial Hero, Horses in the British Army 1750–1850 and Supplying the British Army in the First World War.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?614f5d06